<template>
  <div>
    <b-notification :has-icon="true" icon="database" :closable="false">
      <span v-html="$t('compCarbonFormsVehiclesHelpData.text')" />
    </b-notification>
    <help-file-format />
  </div>
</template>

<script>
export default {
  name: 'HelpData',
  components: {
    'help-file-format': () =>
      import('@/components/carbon/forms/vehicles/HelpFileFormat.vue')
  }
}
</script>
